/**
 * Internal dependencies
 */
import WMUWCReviewList from "./review-list";

/**
 * Vars
 */
const reviewList = new WMUWCReviewList( wmuwcProductReviewsArgs );

/**
 * Init
 */
document.addEventListener( 'DOMContentLoaded', function()
{
	/**
	 * @todo Passer ça par WMUWCReviewList et adapter le fonctionnement
	 */
	document.querySelectorAll( '.product-reviews-module-order-form' ).forEach( ( form ) =>
	{
		const corderSelect = form.querySelector( 'select[name="corder"]' );
		corderSelect.wmuwcLastValue = corderSelect.value;
		corderSelect.addEventListener( 'change', ( event ) =>
		{
			if ( corderSelect.value !== corderSelect.wmuwcLastValue )
			{
				corderSelect.wmuwcLastValue = corderSelect.value;
				// form.submit();
				reviewList.setOrder( corderSelect.value );
			}
		} );
	} );

	reviewList.setup();
} );